import React from "react";
import { Link } from "react-router-dom";

export default function PostStyle5({
  thumbnailSrc,
  title,
  title2,
  subTitle,
  href,
}) {
  return (
    <div className="cs_post cs_style_3 cs_primary_bg bg_dark">
      <div className="cs_post_left">
        <div>
          <h2 className="cs_post_title cs_fs_50 cs_white_color" style={{ marginBottom: "0px" }}>
            <Link to={href}>{title}</Link>
          </h2>
          <h2 className="cs_post_title cs_fs_50 cs_white_color">
            <Link to={href}>{title2}</Link>
          </h2>
        </div>
        <p className="cs_post_subtitle">{subTitle}</p>
        <Link to={href} >
        <div style={{ border: '2px solid #005D9F', borderRadius: '5px', display: 'inline-block', padding: '5px 10px' }}>
  <span>Continue Reading</span>
</div>



        </Link>
      </div>
      <div className="cs_post_right">
        <Link
          to={href}
          className="cs_post_thumb cs_bg_filed"
          style={{ backgroundImage: `url(${thumbnailSrc})` }}
        />
      </div>
    </div>
  );
}
